module.exports = __webpack_public_path__ + "static/media/two.e1c72121.svg";